// UI copy for the Billing components. English is the source of truth per
// BILLING_SPEC.md (US market). The `es` block currently mirrors `en` so the
// existing useI18n()/t() plumbing works end-to-end; Spanish copy is a
// follow-up (PENDING — not translated yet, do not ship as final es copy).
export const billingTranslations = {
  en: {
    pricing: {
      title: 'Plans built around your Active Revenue Opportunities',
      subtitle: 'Pick how many revenue opportunities you want to keep active at once. Upgrade, downgrade, or add capacity anytime.',
      monthly: 'Monthly',
      annual: 'Annual',
      annualSave: (pct) => `Save ${pct}%`,
      perMonth: '/mo',
      perYear: '/yr',
      trialBadge: '7-day free trial',
      quotaLabel: (n) => `${n} Active Revenue Opportunities`,
      addonLabel: 'Extra Active Revenue Opportunities',
      addonPrice: (price) => `+$${price}/mo per opportunity`,
      addonCapNote: (cap) => `Max total: ${cap} Active Revenue Opportunities`,
      selectPlan: 'Choose plan',
      currentPlan: 'Current plan',
      processing: 'Redirecting to checkout…',
      genericError: 'Could not start checkout. Please try again.',
      mostPopular: 'Most popular',
    },
    status: {
      title: 'Billing',
      planLabel: 'Current plan',
      intervalMonthly: 'Monthly',
      intervalAnnual: 'Annual',
      quotaInUse: (used, max) => `${used} of ${max} Active Revenue Opportunities in use`,
      trialDaysLeft: (days) => `${days} day${days === 1 ? '' : 's'} left in trial`,
      trialEnded: 'Trial ended',
      addonsActive: (n) => `${n} extra opportunity add-on${n === 1 ? '' : 's'} active`,
      upgrade: 'Upgrade plan',
      cancel: 'Cancel subscription',
      cancelConfirmTitle: 'Cancel your subscription?',
      cancelConfirmBody: 'Your account will move to the Free plan. Active opportunities stay in place but become read-only until you upgrade again.',
      cancelConfirmCta: 'Yes, cancel',
      cancelConfirmDismiss: 'Keep my plan',
      cancelling: 'Cancelling…',
      cancelError: 'Could not cancel the subscription. Please try again.',
      loadError: 'Could not load billing status. Please try again.',
      loading: 'Loading billing status…',
      statusActive: 'Active',
      statusFrozen: 'Frozen',
      statusCancelled: 'Cancelled',
      statusDeclined: 'Payment declined',
      statusPending: 'Pending approval',
      statusExpired: 'Expired',
    },
    capacity: {
      title: 'Available — free up a slot or upgrade',
      body: 'This account is at its Active Revenue Opportunity limit. Deactivate one to free up space, or upgrade for more capacity.',
      cta: 'View plans',
      lockedTooltip: 'Plan limit reached — upgrade to activate',
      lockedCta: 'Upgrade',
      inUse: (used, max) => `${used} of ${max} Active Revenue Opportunities in use`,
    },
    checkout: {
      success: 'Your subscription is now active.',
      error: 'Something went wrong confirming your subscription. Please try again.',
      reauth: 'Your Shopify connection expired. Please reconnect Shopify and try again.',
      retry: 'Try again',
      dismiss: 'Dismiss',
    },
  },
  es: {
    // PENDING: Spanish copy not localized yet. Mirrors `en` so the app doesn't
    // break if language is switched to es; translate before shipping es UI.
    pricing: {
      title: 'Plans built around your Active Revenue Opportunities',
      subtitle: 'Pick how many revenue opportunities you want to keep active at once. Upgrade, downgrade, or add capacity anytime.',
      monthly: 'Monthly',
      annual: 'Annual',
      annualSave: (pct) => `Save ${pct}%`,
      perMonth: '/mo',
      perYear: '/yr',
      trialBadge: '7-day free trial',
      quotaLabel: (n) => `${n} Active Revenue Opportunities`,
      addonLabel: 'Extra Active Revenue Opportunities',
      addonPrice: (price) => `+$${price}/mo per opportunity`,
      addonCapNote: (cap) => `Max total: ${cap} Active Revenue Opportunities`,
      selectPlan: 'Choose plan',
      currentPlan: 'Current plan',
      processing: 'Redirecting to checkout…',
      genericError: 'Could not start checkout. Please try again.',
      mostPopular: 'Most popular',
    },
    status: {
      title: 'Billing',
      planLabel: 'Current plan',
      intervalMonthly: 'Monthly',
      intervalAnnual: 'Annual',
      quotaInUse: (used, max) => `${used} of ${max} Active Revenue Opportunities in use`,
      trialDaysLeft: (days) => `${days} day${days === 1 ? '' : 's'} left in trial`,
      trialEnded: 'Trial ended',
      addonsActive: (n) => `${n} extra opportunity add-on${n === 1 ? '' : 's'} active`,
      upgrade: 'Upgrade plan',
      cancel: 'Cancel subscription',
      cancelConfirmTitle: 'Cancel your subscription?',
      cancelConfirmBody: 'Your account will move to the Free plan. Active opportunities stay in place but become read-only until you upgrade again.',
      cancelConfirmCta: 'Yes, cancel',
      cancelConfirmDismiss: 'Keep my plan',
      cancelling: 'Cancelling…',
      cancelError: 'Could not cancel the subscription. Please try again.',
      loadError: 'Could not load billing status. Please try again.',
      loading: 'Loading billing status…',
      statusActive: 'Active',
      statusFrozen: 'Frozen',
      statusCancelled: 'Cancelled',
      statusDeclined: 'Payment declined',
      statusPending: 'Pending approval',
      statusExpired: 'Expired',
    },
    capacity: {
      title: 'Available — free up a slot or upgrade',
      body: 'This account is at its Active Revenue Opportunity limit. Deactivate one to free up space, or upgrade for more capacity.',
      cta: 'View plans',
      lockedTooltip: 'Plan limit reached — upgrade to activate',
      lockedCta: 'Upgrade',
      inUse: (used, max) => `${used} of ${max} Active Revenue Opportunities in use`,
    },
    checkout: {
      success: 'Your subscription is now active.',
      error: 'Something went wrong confirming your subscription. Please try again.',
      reauth: 'Your Shopify connection expired. Please reconnect Shopify and try again.',
      retry: 'Try again',
      dismiss: 'Dismiss',
    },
  },
};
